import React, { useState, useEffect } from "react";
import { ReactComponent as TrashIcon } from "../img/trashicon.svg";
import { ReactComponent as PlusIcon } from "../img/plusicon.svg";
import Select from "react-select";
import { instance2 } from "../utils/axiosInstance";
import { ReactComponent as EditIcon } from "../img/editicon.svg";
import { EyeIcon } from '@heroicons/react/16/solid';
import { useNavigate } from "react-router-dom";
import { ReactComponent as VerticalLine } from "../img/verticalline.svg";
import { ReactComponent as MagnificationLogo } from "../img/magnificationlensicon.svg";

const currentYear = new Date().getFullYear();
const roleId = parseInt(localStorage.getItem("roleId"));
export default function DaftarHariLibur() {
  const [data, setData] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [errorData, setErrorData] = useState(null);
  const [userId, setUserId] = useState("");
    const navigate = useNavigate();
      const [searchQuery, setSearchQuery] = useState(""); // State for search input

      const localDateString = (thedate) =>{

        const year = thedate.getFullYear();
        const month = String(thedate.getMonth() + 1).padStart(2, '0');  // Adding 1 because months are 0-based
        const day = String(thedate.getDate()).padStart(2, '0');
        
      console.log("startDate", thedate);
      const localDateString = `${year}-${month}-${day}`;
      
      return localDateString
      
      }
      const [selectedYear, setSelectedYear] = useState(currentYear); // Default to current year
  // Fetch ingredient categories

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    date: "",
  }); 
  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");
    if (storedUserId) {
      setUserId(parseInt(storedUserId, 10)); // Ensure userId is an integer
      setFormData((prev) => ({
        ...prev,
        admin_id: parseInt(storedUserId, 10), // Automatically update admin_id
      }));
    }
  }, []);

  // Fetch holiday data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await instance2.get("holidays");
        setData(response.data); // Access the appropriate field in the response
      } catch (err) {
        setErrorData(err.message);
      } finally {
        setLoadingData(false);
      }
    };
  
    fetchData();
  }, []);
  //wew

    const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" }); // Sort state
  const handleSort = (key) => {
    const newDirection =
      sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) return newDirection === "asc" ? -1 : 1;
      if (a[key] > b[key]) return newDirection === "asc" ? 1 : -1;
      return 0;
    });
    setData(sortedData);
    setSortConfig({ key, direction: newDirection });
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "▲" : "▼";
    }
    return "";
  };

  const filteredData = data.filter((item) => {
    const formattedDate = new Date(item.date).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).toLowerCase(); // Convert to lowercase for case-insensitive search
    const itemYear = new Date(item.date).getFullYear();
    const searchValue = searchQuery.toLowerCase();

    return (
      itemYear === selectedYear &&
      (
      (formattedDate.includes(searchQuery.toLowerCase()) ) ||
      (item.name?.toLowerCase().includes(searchValue) || false) ||
      (item.description?.toLowerCase().includes(searchValue) || false)) 
    );
  });

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
  
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const paginatedData = filteredData.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  
    const handlePreviousPage = () => {
      if (currentPage > 1) setCurrentPage(currentPage - 1);
    };
  
    const handleNextPage = () => {
      if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };
  
    // Determine which page numbers to show
    let pageNumbers = [];
    const maxVisiblePages = 5;
  
    if (totalPages <= maxVisiblePages) {
      pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      if (currentPage <= 3) {
        // Near the beginning
        pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
      } else if (currentPage >= totalPages - 2) {
        // Near the end
        pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
      } else {
        // In the middle
        pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
      }
    }
  // Function to get all years from 2024 to current year
  const getYears = () => {
    let years = [];
    for (let year = 2024; year <= currentYear; year++) {
      years.push(year);
    }
    return years.reverse(); // Show latest year first
  };

  return (
    <div className="p-4">
  

  {/* Table Section */}
  
  <div className="flex flex-col items-start md:flex-row lg:flex-row md:items-center lg:items-center justify-between">
      <h2 className="block text-black text-xl sm:text-2xl my-2 font-medium">Daftar Hari Libur</h2>
      {roleId === 1 || roleId === 4 ? 
      <button
        type="button"
        onClick={() => navigate("/tambahharilibur")}
        className="rounded-[25px] px-8 py-4 bg-merah-no hover:bg-merah-hover text-white text-xxs md:text-xxs lg:text-base"
      >
        Tambah Hari Libur
      </button>
      :"" }
    </div>
  {loadingData && <p>Loading...</p>}
  {errorData && <p className="text-red-500">{errorData}</p>}
  {!loadingData && data.length === 0 && <p>No data available</p>}
  {!loadingData && data.length > 0 && (
    <>  
    {/* Search Bar */}
          <div className="flex py-4 rounded-[50px] flex-col md:flex-row lg:flex-row md:items-center lg:items-center justify-start items-start gap-2">
            <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center justify-start">
              <MagnificationLogo className="w-6 h-6" />
              <VerticalLine className="mx-1" />
              <input
                type="text"
                placeholder="Telusuri data berdasarkan tanggal, nama hari libur, atau keterangan"
                className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-xxs md:text-xxs lg:text-base"
                style={{
                  width: `${"Telusuri data berdasarkan tanggal, nama hari libur, atau keterangan".length}ch`,
                }}
                value={searchQuery} // Controlled input
                onChange={(e) => setSearchQuery(e.target.value)} // Update search query
              />
            </div>
             {/* Year Filter */}
      <div className="flex items-center gap-4">
        <label className="text-md text-black text-xxs md:text-xxs lg:text-base">Tahun:</label>
        <select
          value={selectedYear}
          onChange={(e) => setSelectedYear(parseInt(e.target.value))}
          className="px-2 py-4 border border-gray-300 rounded-[25px] outline-none border-none text-xxs md:text-xxs lg:text-base "
                style={{
                  width: `${"9999999999".length}ch`,
                }}
        >
          {getYears().map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
          </div>
      <table className="table-fixed w-full border-gray-300">
        <thead>
          <tr className="bg-white">
            <th className=" w-[25px] lg:w-[50px] border-b border-gray-300 px-2 sm:px-4 py-2 rounded-tl-[15px] text-center text-xxs md:text-xxs lg:text-base">
              No.
            </th>
                <th
                  className="w-1/6 border-b border-gray-300 px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base cursor-pointer"
                  onClick={() => handleSort("date")}
                >
                  Tanggal <span className="float-right">{getSortArrow("date")}</span>
                </th>
                <th
                  className="w-1/2 border-b border-gray-300 px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base cursor-pointer"
                  onClick={() => handleSort("name")}
                >
                  Libur <span className="float-right">{getSortArrow("name")}</span>
                </th>
            {/* <th className="border-b border-gray-300 px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
              Keterangan
            </th> */}
            
                <th
                  className="border-b border-gray-300 px-2 sm:px-4 py-2 rounded-tr-[15px] text-center text-xxs md:text-xxs lg:text-base"
                >
                  Aksi
                </th>
          </tr>
        </thead>
        <tbody>
          {[
    ...paginatedData,
    ...Array.from({ length: itemsPerPage - paginatedData.length }).map((_, index) => ({
      empty: true, // Add an "empty" object for invisible rows
    })),
  ].map((item, index) => (
    <tr
    key={item.id}
    className={`hover:bg-gray-200 ${
      index % 2 === 0 ? "bg-bg-gray-100" : "bg-white"
    } ${item.empty ? "invisible border-b border-transparent" : "border-b border-gray-300 "}`}
  >
              <td className="w-[25px] lg:w-[50px] px-2 sm:px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">
              {index + 1 + (currentPage - 1) * itemsPerPage}
              </td>
              <td className="px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
                {new Date(item.date).toLocaleDateString('id-ID', {
            year: 'numeric',
            month: 'long',
            day: '2-digit',
          })}
              </td>
              <td className="px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
                {item.name}
              </td>
              {/* <td className="px-2 sm:px-4 py-2 text-left text-xxs md:text-xxs lg:text-base">
                {item.description}
              </td> */}
                                <td className="px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">
                                <button
                                    className="text-gray-500 p-2 rounded hover:text-green-500"
                                    // onClick={() => handleEdit(item)}
                                  >
                                    <EditIcon className="w-4 h-4 md:w-4 md:h-4 lg:w-5 lg:h-5" 
                        onClick={() => navigate(`/editharilibur?id=${item.id}`)}/>
                                  </button>

                                </td>
            </tr>
          ))}
        </tbody>
      </table>

         
{/* Pagination Controls */}
<div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
      {/* Previous Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
      >
        <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center">
        {pageNumbers.map((page, index) => (
          <span
            key={index}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
              currentPage === page ? "text-black font-semibold" : "text-gray-700"
            } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
          >
            {page}
          </span>
        ))}
      </div>

      {/* Next Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <span className="font-bold text-lg sm:text-2xl">{">"}</span>
      </button>
    </div>
    </>
  )}
</div>

  );
}
